import React, { memo, useRef, useEffect } from 'react';
import classes from './override.module.scss';

type Props = {};

export const NotFoundTemplate = memo((_props: Props) => {
	const returnTop = () => {
		window.location.href = '/';
	};

	const scrollRef = useRef(null);
	useEffect(() => {
		scrollRef.current.scrollIntoView();
		document.title = 'GakkenID ご指定のページがみつかりません';
	}, []);

	return (
		<>
			<section className="section">
				<div className="section-in" ref={scrollRef}>
					<div className="section-txt-box">
						<div className={classes.notFoundTitle}>ご指定のページがみつかりません。</div>
						<p>
							指定したURLが間違っているか、お探しのページが削除された可能性があります。
							<br />
							お手数ですが、GakkenIDトップページより目的のページへアクセスしてください。
						</p>
					</div>
					<div className="btn-box">
						<div className="btn gr">
							<button onClick={returnTop}>GakkenIDページTOPへ戻る</button>
						</div>
					</div>
				</div>
			</section>
		</>
	);
});
